import styled from 'styled-components';

export const Container = styled.div`
  text-align: center;
  width: 710px;
  margin: 0 auto;
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    width: calc(100% - 24px);
    margin: 0 ${(props) => props.theme.spacing.ELEM_SPACING.SM};
    margin-top: 96px;
  }

  margin-top: 96px;
`;

export const Paragraph = styled.p`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  border: 1px solid #162E41;
  border-radius: ${(props) => props.theme.spacing.ELEM_SPACING.XS_6};
  padding: ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
`;

export const BoldText = styled.strong`
  font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
  font-weight: ${(props) => props.theme.fonts.fontWeight.bold};
  font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy4}px;
  line-height: 21.82px;
`;

export const NonBoldText = styled.span`
  font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
  font-weight: ${(props) => props.theme.fonts.fontWeight.normal};
  font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy4}px;
  line-height: 21.82px;
`;
